import React from 'react';
import styles from './CallToActionButton.module.css';

interface CallToActionButtonProps {
  href: string;
  text: string;
  className?: string;
  external?: boolean;
  trackingValue?: string;
  trackingEvent?: string;
}

const CallToActionButton: React.FC<CallToActionButtonProps> = ({
  href,
  text,
  className = '',
  external = true,
  trackingValue,
  trackingEvent = 'product-click',
}) => {
  const externalProps = external
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {};

  const umamiProps = trackingValue
    ? {
        'data-umami-event': trackingEvent,
        'data-umami-event-value': trackingValue,
        'data-umami-event-context': 'page',
      }
    : {};

  return (
    <a
      href={href}
      {...externalProps}
      {...umamiProps}
      className={`inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors text-center mb-6 ${styles.ctaButton} ${className}`}
    >
      {text}
    </a>
  );
};

export default CallToActionButton;
